import React from "react";
import EUTable from "./EUTable/EUTable";

export default function EUCard(props) {
    const { eu_data } = props
    const hasSource = Object.keys(eu_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                União Europeia - Match por similaridade encontrado
            </p>
            <EUTable eu_data={eu_data.source} />
        </div>
    )
}
